import { NgModule } from '@angular/core';;
import { CommonModule } from '@angular/common';
import { CustomizeFieldAdddealComponent } from './customize-field-adddeal.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbTooltipModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { ImDatePickerModule } from 'app/shared-modules/im-date-picker/im-date-picker.module';



@NgModule({
  declarations: [
    CustomizeFieldAdddealComponent,
  ],
  exports: [
    CustomizeFieldAdddealComponent
  ],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
    NgbTooltipModule,
    NgbPopoverModule,
    NgSelectModule,
    ImDatePickerModule,
  ]
})
export class CustomizeFieldAdddealModule { }
